import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'marionhealth-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'MyMCPHDChart',
  welcomeText: '',
  fillColor: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 371-221-2000,
  email: 'support@marionhealth.org',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/marionhealth/index.js